import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Panel } from 'src/Components'

const EmptyState = () => (
  <FormattedMessage
    id='Homeowner.interestCard.noInterestPayments.headline'
    defaultMessage="Let's get started building your wealth"
  />
)

const DefaultHeadline = () => (
  <FormattedMessage
    id='Homeowner.interestCard.headline'
    defaultMessage="What you've paid so far"
  />
)

const Headline = ({ emptyState }) => (
  <Panel.Heading data-qa='interestSectionHeadline'>
    {emptyState ? <EmptyState /> : <DefaultHeadline />}
  </Panel.Heading>
)

export default Headline
